import { useEffect, useState } from 'react';
import loadYMaps from '../utils/loadYMaps';
var loaderState = {
    loading: true
};
export var useMapLoader = function (params) {
    if (params === void 0) { params = {}; }
    var _a = params.version, version = _a === void 0 ? '2.1' : _a, _b = params.lang, lang = _b === void 0 ? 'ru_RU' : _b, load = params.load, coordorder = params.coordorder, mode = params.mode;
    var _c = useState(loaderState), state = _c[0], setState = _c[1];
    useEffect(function () {
        loadYMaps({
            version: version,
            lang: lang,
            load: load,
            coordorder: coordorder,
            mode: mode
        })
            .then(function () {
            return setState({
                loading: false
            });
        })
            .catch(function (error) {
            return setState({
                loading: false,
                error: error
            });
        });
    }, [coordorder, lang, load, mode, version]);
    return state;
};
